import { useEffect, useState } from 'react';
import { fetchMyProfiles } from '../utils/api'; 
import { ClipLoader } from "react-spinners";

export function ProfileListsContent() {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const data = await fetchMyProfiles();
        setProfiles(data);
      } catch (err) {
        console.error('Error loading profiles:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const getStatusClasses = (status) => {
    switch (status) {
      case 'Accepted':
        return 'bg-green-100 text-green-800';
      case 'Pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'Denied':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  if (loading) {
    return (
      <div className="flex-1 p-8 bg-gray-50 flex items-center justify-center">
        {/* Simple loading indicator */}
        <ClipLoader />
      </div>
    );
  }

  return (
    <div className="flex-1 p-8 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          <div className="p-6 border-b border-gray-200">
            <h2 className="text-xl font-semibold text-gray-800">Profile Lists</h2>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  {['Sno', 'Name', 'Age', 'Status'].map((h) => (
                    <th
                      key={h}
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-white">
                {error && (
                  <tr>
                    <td colSpan="5" className="px-6 py-4 text-center text-red-500">
                      {error}
                    </td>
                  </tr>
                )}

                {!error && profiles.length === 0 && (
                  <tr>
                    <td colSpan="5" className="px-6 py-12 text-center text-gray-500">
                      You have no profiles listed yet.
                    </td>
                  </tr>
                )}

                {!error && profiles.map((p, idx) => (
                  <tr key={p._id} className="border-t">
                    <td className="px-6 py-4 whitespace-nowrap">{idx + 1}</td>
                    <td className="px-6 py-4 whitespace-nowrap">{p.fullName}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {new Date().getFullYear() - new Date(p.dob).getFullYear()}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusClasses(p.status)}`}>  
                        {p.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
